<template>
  <fulfilling-bouncing-circle-spinner
    class="spinner"
    :animation-duration="4000"
    :size="62"
    :color="'#D0000A'"
  />
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners';

export default {
  components: {
    FulfillingBouncingCircleSpinner,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/uikit/SpinnerEl.vue